import { useShallow } from 'zustand/react/shallow';

// Import hooks
import { useSummaryStore, useCalculatedPrice } from 'components/views/offer_configurator/hooks';

// Import helpers
import { getCalculatedPrice } from 'components/views/offer_configurator/helpers/packets';
import { sendPacketAddToCartEvent } from 'helpers/tracking';

// Import types
import type { PacketWithPriceAndChannels } from 'types/views/configurator';

export const usePremiumPacketsSummary = () => {
	const [action, premium, setPremium] = useSummaryStore(useShallow((state) => [state.action, state.premium, state.setPremium]));

	const calculated = useCalculatedPrice();

	const onSelect = ({ uuid, price_id, title, subtype }: PacketWithPriceAndChannels) => {
		const isCancel = premium.some((packet) => packet.uuid === uuid);

		if (!isCancel) {
			const price = getCalculatedPrice(uuid, calculated);
			sendPacketAddToCartEvent({ item_id: uuid, item_name: title, subtype, price: price?.current_price });
		}

		setPremium({ uuid, price_id });
	};

	return { action, premium, calculated, onSelect };
};
